import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Menumain from '../partils/menus/menumain';
import Menumobile from '../partils/menus/menumobile'
// DATA -------------------------------------------------------------------------

  

function Painel() {
    const [loading,setLoading]=useState(false)
    

    
    
    
  return(
    <div className='w100 h100 b33 row around celular '>
      {loading&&
      <div className='w100 h100 fundo-opaco posiabste column center'>
          <img src="https://i.pinimg.com/474x/67/d8/37/67d8379604084dd7d7c7fa8d41f4c739.jpg"></img>
      </div>
      }

     
      <div className='w15 cell-tamanho cell-none'>
        <Menumain className="w100"/>
      </div>
      
    
      
      <div className='w80 h90 cont-circ7 cell-tamanho90 row center'>
        

    
        <div className='w100 h15 b32 cont-circ7 bordaElements row between'>
          <div className='row w60 cell-tamanho75'>
            <div className='w15 h10  cont-circ7 column center cell-tamanho-metade35 bordaElements'>
              
             <label>Logo</label>
            </div>
            <div className='w60 column m15 cell-tamanho-metade50'>
              <label className='w100 c3'>User</label>
              <label className='w100 c3'>Geovane Filgueira de Almeida</label>
              
            </div>
          </div>

          <div className='row cell-tamanho20 w10'>
            <div className=' w20 column center p10'>
              <label className='c3'>Tokens</label>
              <label className='c3'>7</label>
            </div>
          </div>
        </div>

        
        {/*

        <div className='ma10b0 w100 column'>
          <label className='fs1p1em w100' >O que gostaria de fazer?</label>
          <label className='w100 ma5' >What would you like to do?</label>
          
        </div>
        <div className='w100 h10 cont-circ7 overflow '>
          <div className='row we2200 h10 ma5'>
            <Link to="/engine"
              className='b2 h10 cont-circ7 ml10 column center pp sobhover bordaElements '>
              <img src='https://cdn-icons-png.flaticon.com/128/5721/5721461.png' className='w20' alt='plus / mais'/>
              <label className='fw500 pcb7 pp fs08em c1' >New Post</label>
            </Link>

            <div className='b2 h10 cont-circ7 ml10 column center pp sobhover bordaElements '>
              <img src='https://cdn-icons-png.flaticon.com/128/1065/1065281.png' className='w20' alt='plus / mais'/>
              <label className='fw500 pcb7 pp fs08em c1' >New Story</label>
            </div>
            <div className='b2 h10 cont-circ7 ml10 column center pp sobhover bordaElements '>
              <img src='https://cdn-icons-png.flaticon.com/128/6041/6041393.png' className='w20' alt='plus / mais'/>
              <label className='fw500 pcb7 pp fs08em c1' >hashtag</label>
            </div>
          </div>
        </div>
        */}
        <div className='ma10b0 w100'>
          <label className='fs1p1em'>Histórico/Historic</label>
        </div>
        <div className='w100 h50 b2 cont-circ7 bordaElements'>
          <div className='w100 linha pcb7 row between b16'>
            <label className='w35 ml10 c1 fw500 fs08em'>Title</label>
            <label className='w20 c1 fw500 fs08em'>Created</label>
            <label className='w10 c1 fw500 fs08em'>Date</label>
            <label className='w10 c1 fw500 fs08em'>Hour</label>
            <label className='w15 c1 fw500 fs08em'>Acti.</label>
          </div>
          <div className='w100 linha pcb7 row between'>
            <label className='w35 ml10 c1'>Campanha de aquisição de clientes</label>
            <label className='w20  c4'>HelloPost</label>
            <label className='w10  c4'>13/11/2023</label>
            <label className='w10  c4'>21:00</label>
            <label className='w15  c7 fw500 pp'>Open</label>
          </div>
          <div className='w100 linha pcb7 row between'>
            <label className='w35 ml10 c1'>Campanha de Engajamento</label>
            <label className='w20 c4'>HelloPost</label>
            <label className='w10 c4'>14/11/2023</label>
            <label className='w10 c4'>10:00</label>
            <label className='w15 c7 fw500 pp'>Open</label>
          </div>
        </div>

        <div className='w95 row center h10'>
          <label className='cen c2'>
            Hello Post 2022- By Mobi Apps V.BETA
          </label>
        </div>
        <Menumobile/>
      </div>
    </div>
    
  )

}

export default Painel;